import { I18n } from 'i18n';

export const keydownHandler = (event) => {
    if (event.key === "Enter" || event.keyCode === 13) {
        event.preventDefault();
        event.target.click();
    }
}
export const i18n = new I18n({
    locales: ['en', 'es'],
    staticCatalog: {
        es: require('../locales/es.json'),
        en: require('../locales/en.json'),
    },
    defaultLocale: 'en',
})

export const jsonParse = (data) => {
    let result = null;
    try {
        result = JSON.parse(data);
    } catch (e) {}
    return result;
}


export const setLocalStorageData = (key, data) => {
    if (!key) {
        console.warn('Key is not defined');
        return;
    }

    try {
        let existingData = localStorage.getItem(key);
        let parsedData = {};

        if (existingData) {
            parsedData = jsonParse(existingData);

            if (typeof parsedData === 'object' && typeof data === 'object') {
                parsedData = { ...parsedData, ...data };
            } else {
                parsedData = data;
            }
        } else {
            parsedData = data;
        }

        localStorage.setItem(key, JSON.stringify(parsedData));

    } catch (e) {
        console.error('Error setting to LocalStorage:', e);
    }
};

export const getLocalStorageData = (key) => {
    if (!key) {
        console.warn('Key is not defined');
        return {};
    }

    try {
        const serializedData = localStorage.getItem(key);
        return serializedData ? jsonParse(serializedData) : {};
    } catch (e) {
        console.error('Error parsing date from LocalStorage:', e);
    }

    return null;
};

export const removeLocalStorageData = (key) => {
    if (!key) {
        console.warn('Key is not defined');
        return;
    }

    try {
        localStorage.removeItem(key);
    } catch (e) {
        console.error('Error removing date from LocalStorage:', e);
    }
};

export const hashCode = (data) => {
    var hash = 0, i, chr;
    if (data.length === 0) {
        return hash;
    }
    for (i = 0; i < data.length; i++) {
        chr   = data.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export const getTimeAMPMFormat = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    hours = hours < 10 ? '0' + hours : hours;
    // appending zero in the start if hours less than 10
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + minutes + ' ' + ampm;
};

export const checkEmptyInputText = (text) => {
    return text.replace(/\s+/g, '') === '';
}

export const openUrl = (url, newWindow, targetOrigin) => {
    if (window.parent) {
        const data = {
            name: 'linkClick',
            value: url,
            newWindow: newWindow || false,
        };
        window.parent.postMessage(data, targetOrigin || '*');
    }
}
